import React from 'react'
import { VerifiedItem } from './styles'
import { AcademyVerified } from '../../../../Api'
import { Img } from '../../../../Components/Image/Img'
import { NEW_PLL_IMAGE_URL } from '../../../../Config/config'

type VerifiedClubParams = {
  club: AcademyVerified
}

export const VerifiedClub: React.FC<VerifiedClubParams> = ({ club }) => {
  return (
    <VerifiedItem>
      <div className="imgCon">
        <Img src={`${NEW_PLL_IMAGE_URL}/${club.imageUrl}`} alt={club.clubName} />
      </div>
      <p>{club.clubName}</p>
      <div className="location">{club.location}</div>
    </VerifiedItem>
  )
}
